import { render, staticRenderFns } from "./SalesReportTab.vue?vue&type=template&id=2247ea2a&scoped=true&"
import script from "./SalesReportTab.vue?vue&type=script&lang=js&"
export * from "./SalesReportTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2247ea2a",
  null
  
)

export default component.exports